import { colors } from '@chegg-ui/theme';
export var getSiteColor = function getSiteColor(site) {
  switch (site) {
    case 'chegg':
      return colors.orange800;
    case 'bibme':
      return '#228EB5';
    case 'citethisforme':
      return '#2E5899';
    case 'citationmachine':
      return '#D47D35';
    case 'easybib':
      return colors.orange800;
    default:
      return colors.orange800;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/utils/getSiteColor.js
// module id = 1319
// module chunks = 11